/** Official GST — search taxpayer by GSTIN / PAN (public) */
export const GST_SEARCH_TAXPAYER_URL = "https://services.gst.gov.in/services/quicklinks/searchtxp";

/** Official GST portal */
export const GST_PORTAL_HOME_URL = "https://www.gst.gov.in/";

/** Official MCA — company / LLP master data */
export const MCA_COMPANY_MASTER_URL =
  "https://www.mca.gov.in/content/mca/global/en/mca/master-data/MDS/company-master-info.html";
